import Habitacion from "../models/Habitacion";
import Imagen from "../models/Imagen";

function generarHabitacion1() {

    const descripcionesHab1: string[] = [
        "El Albergue de Griegos cuenta con una habitación familiar con literas de hasta 4 plazas con su baño privado.",
        "Bajo petición se puede aumentar hasta una cama más.",
        "La habitación está equipada con ropa de cama y toallas."
    ];

    const imagenesHab1: Imagen[] = [
        new Imagen("./img/sections/hab/fam_01.jpg",""),
        new Imagen("./img/sections/hab/fam_02.jpg",""),
        new Imagen("./img/sections/hab/fam_03.jpg","")
    ];

    const descricionesTarifaHab1: string[] = [
        "El precio por noche y personas son 20€ con el desayuno incluido."
    ];
    
    return new Habitacion("modalHabitacion1", "Habitacion Familiar", descripcionesHab1 , "fa-solid fa-bed", imagenesHab1, "Tarifa:", descricionesTarifaHab1)

}

function generarHabitacion2() {
    
    const descripcionesHab2: string[] = [
        "Contamos con dos habitaciones dobles con cama de matrimonio y baño privado.",
        "Las habitaciones están equipadas con ropa de cama y toallas."
    ];

    const imagenesHab2: Imagen[] = [
        new Imagen("./img/sections/hab/dob_mat_01.jpg",""),
        new Imagen("./img/sections/hab/dob_mat_02.jpg",""),
        new Imagen("./img/sections/hab/dob_mat_03.jpg",""),
        new Imagen("./img/sections/hab/dob_mat_04.jpg",""),
        new Imagen("./img/sections/hab/dob_mat_05.jpg",""),
        new Imagen("./img/sections/hab/dob_mat_06.jpg",""),
        new Imagen("./img/sections/hab/dob_mat_07.jpg","")
    ];

    const descricionesTarifaHab2: string[] = [
        "El precio por noche para dos personas son 50€ con el desayuno incluido y para una sola personas 35€."
    ];

    return new Habitacion("modalHabitacion2", "Habitación Doble Matrimonio", descripcionesHab2, "fa-solid fa-bed", imagenesHab2, "Tarifa:", descricionesTarifaHab2);

}

function generarHabitacion3() {
    
    const descripcionesHab3: string[] = [
        "Tenemos cinco habitaciones compartidas con literas y cada habitación tiene su baño, no comparte baño con todo el albergue.",
        "La distribución de estas habitaciones son; 14 plazas, 12 plazas, 12 plazas y 12 plazas.",
        "Las habitaciones están equipadas con ropa de cama y toallas."
    ];

    const imagenesHab3: Imagen[] = [
        new Imagen("./img/sections/hab/com_01.jpg",""),
        new Imagen("./img/sections/hab/com_02.jpg",""),
        new Imagen("./img/sections/hab/com_03.jpg",""),
        new Imagen("./img/sections/hab/com_04.jpg",""),
        new Imagen("./img/sections/hab/com_05.jpg",""),
        new Imagen("./img/sections/hab/com_06.jpg",""),
        new Imagen("./img/sections/hab/com_07.jpg","")
    ];

    const descricionesTarifaHab3: string[] = [
        "El precio por noche y personas son 20€ con el desayuno incluido."
    ];

    return new Habitacion("modalHabitacion3", "Habitación Compartida", descripcionesHab3, "fa-solid fa-bed", imagenesHab3, "Tarifa:", descricionesTarifaHab3);

}

function generarHabitacion4() {
    
    const descripcionesHab4: string[] = [
        "La habitación doble con dos camas y baño privado esta equipadas con ropa de cama y toallas.",
        "Esta habitación esta adaptada para minusválidos y todas las zonas comunes del albergue son aptas para estos."
    ];

    const imagenesHab4: Imagen[] = [
        new Imagen("./img/sections/hab/dob_dos_cam_01.jpg", ""),
        new Imagen("./img/sections/hab/dob_dos_cam_02.jpg", ""),
        new Imagen("./img/sections/hab/dob_dos_cam_03.jpg", "")
    ];

    const descricionesTarifaHab4: string[] = [
        "El precio por noche para dos personas son 50€ con el desayuno incluido y para una sola personas 35€."
    ];

    return new Habitacion("modalHabitacion4", "Habitación Doble Dos Camas", descripcionesHab4, "fa-solid fa-bed", imagenesHab4, "Tarifa:", descricionesTarifaHab4);

}

function generarHabitacion5() {
    
    const descripcionesHab5: string[] = [
        "¿Vienes en grupo y quieres pasar unos días en Griegos?"
    ];

    const imagenesHab5: Imagen[] = [
        new Imagen("./img/sections/hab5.jpg", "")
    ];

    const descricionesTarifaHab5: string[] = [
        "Tenemos tarifas especiales para grupos a partir de 15 personas, con opción de media pensión o pensión completa.",
        "Contacta con nosotros y pregúntanos."
    ];

    return new Habitacion("modalHabitacion5", "Grupos", descripcionesHab5, "fa-solid fa-bed", imagenesHab5, "Tarifa:", descricionesTarifaHab5);

}

export const getHabitaciones = () => {
    
    const habitaciones: Habitacion[] = [
        generarHabitacion1(),
        generarHabitacion2(),
        generarHabitacion3(),
        generarHabitacion4(),
        generarHabitacion5()
    ];

    return habitaciones;

}